import { UseFormReturnType } from '@mantine/form';
import { useBasicSmartAssistantForms } from 'hooks/SmartAssistantForms/use-basic-smart-assistant-forms';
import { useMessagingSmartAssistantForms } from 'hooks/SmartAssistantForms/use-messaging-smart-assistant-forms';
import { usePhoneSmartAssistantForms } from 'hooks/SmartAssistantForms/use-phone-smart-assistant-forms';
import { useShopifySmartAssistantForms } from 'hooks/SmartAssistantForms/use-shopify-smart-assistant-forms';
import { useWebsiteSmartAssistantForms } from 'hooks/SmartAssistantForms/use-website-smart-assistant-forms';
import { ConfigurationFormValues, SmartAssistant, SmartAssistantType } from 'shared/interfaces/SmartAssistant';

export function useCommonConfigurationForm(
  type: SmartAssistantType,
  smartAssistant?: SmartAssistant
): UseFormReturnType<ConfigurationFormValues> {
  switch (type) {
    case SmartAssistantType.BASIC:
      return useBasicSmartAssistantForms(smartAssistant).configurationForm;
    case SmartAssistantType.SHOPIFY:
      return useShopifySmartAssistantForms(smartAssistant).configurationForm;
    case SmartAssistantType.WHATSAPP:
    case SmartAssistantType.FACEBOOK:
    case SmartAssistantType.INSTAGRAM:
    case SmartAssistantType.DISCORD:
      return useMessagingSmartAssistantForms(smartAssistant).configurationForm;
    case SmartAssistantType.WEBSITE:
      return useWebsiteSmartAssistantForms(smartAssistant).configurationForm;
    case SmartAssistantType.PHONE:
      return usePhoneSmartAssistantForms(smartAssistant).configurationForm;
    // ADD NEW CASES FOR NEW SMART ASSISTANT TYPES
    default:
      return useBasicSmartAssistantForms(smartAssistant).configurationForm;
  }
}
